import { render } from "./LesRecollectionsPage.vue?vue&type=template&id=65dd7b35"
import script from "./LesRecollectionsPage.vue?vue&type=script&lang=js"
export * from "./LesRecollectionsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__